import React, { useState, useEffect } from 'react';
import { DockviewReact } from 'dockview';
import DashboardCust from './DashboardCust';
import { useNavigate } from 'react-router-dom';
import Icon from '../components/utils';



// Initialize panelCount
let panelCount = localStorage.getItem('count') ? localStorage.getItem('count') : 0;

const DockviewPersistence = (props) => {
    const [api, setApi] = useState(null);
    const [layout, setLayout] = useState(null);
    const navigate = useNavigate()


    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [selectedValues, setSelectedValues] = useState({
        dropdown1: '', // Set the initial value for dropdown1
        dropdown2: '',      // Set the initial value for dropdown2
        dropdown3: '',             // Set the initial value for dropdown3
    });

    const [tabSelectedValues, setTabSelectedValues] = useState({});

    const components = {
        tab1: (props) => (
            <DashboardCust graphData={props} />
        )
    };


    const onReady = (event) => {
        setApi(event.api);
    };

    // Handle resizing on window resize
    const handleResize = () => {
        api?.layout(window.innerWidth, window.innerHeight);
    };

    // Add resize event listener
    useEffect(() => {
        setTimeout(() => {
            window.addEventListener('resize', handleResize);
            handleResize();

            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }, 500)

    }, [api]);

    // Seve Lyout on click
    const saveLayout = () => {
        if (api) {
            const currentLayout = api.toJSON();
            localStorage.setItem('saved_layout', JSON.stringify(currentLayout));
            console.log('Layout saved to localStorage.');
        }
    };

    // Get saved layout from localstorage on load
    useEffect(() => {
        const savedLayout = localStorage.getItem('saved_layout');
        if (savedLayout) {
            try {
                const parsedLayout = JSON.parse(savedLayout);
                setLayout(parsedLayout);
                console.log('Layout loaded from localStorage.');
            } catch (error) {
                console.error('Error loading layout from localStorage:', error);
            }
        }
    }, []);

    // Load layout
    useEffect(() => {
        if (api && layout) {
            api.fromJSON(layout);
        }
    }, [api, layout]);


    // Logout
    const logout = () => {
        localStorage.removeItem('userObj')
        setTimeout(() => {
            navigate('/')
        }, 500)
    }

    // Function to add a panel
    function addPanel(api) {
        // Generate a unique ID based on the updated panelCount
        const newPanelId = (++panelCount).toString();

        const newTabSelectedValues = { ...tabSelectedValues };
        // Set the selected values for the new tab (customize as needed)
        newTabSelectedValues[newPanelId] = { dropdown1: selectedValues.dropdown1, dropdown2: selectedValues.dropdown2, dropdown3: selectedValues.dropdown3, tabID: `Tab ${newPanelId}` };

        // Update tabSelectedValues state with the new values
        setTabSelectedValues(newTabSelectedValues);

        // Also, save the updated tabSelectedValues object in local storage
        localStorage.setItem('tabSelectedValues', JSON.stringify(newTabSelectedValues));

        api.addPanel({
            id: newPanelId,
            title: `Tab ${newPanelId}`,
            component: 'tab1',
            params: {
                graphData: selectedValues
            }

        });

        localStorage.setItem('count', panelCount)

    }


    // Right header component
    const RightComponent = (props) => {
        const [floating, setFloating] = useState(props.api.isFloating);

        useEffect(() => {
            const disposable = props.group.api.onDidFloatingStateChange((event) => {
                setFloating(event.isFloating);
            });

            return () => {
                disposable.dispose();
            };
        }, [props.group.api]);

        const onClick = () => {
            if (floating) {
                const group = props.containerApi.addGroup();
                props.group.api.moveTo({ group });
            } else {
                props.containerApi.addFloatingGroup(props.group);
            }
        };

        return (
            <div style={{ height: '100%', color: 'white', padding: '0px 4px' }}>
                <Icon
                    onClick={onClick}
                    icon={floating ? 'jump_to_element' : 'back_to_tab'}
                />
            </div>
        );
    };


    const toggleDropdown = () => {
        setIsDropdownVisible(!isDropdownVisible);
    };

    const handleDropdownChange = (event) => {
        const { name, value } = event.target;
        setSelectedValues({
            ...selectedValues,
            [name]: value,
        });
    };


    return (
        <div className='main-dock'
            style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
            }}
        >
            <div className='flex flex-row justify-between items-center p-1' style={{ background: '#23bbf3' }}>
                <div className='pl-2 font-bold'>
                    Chart
                </div>
                <div className='pr-2'>
                    <span class="material-symbols-outlined" onClick={logout} style={{ cursor: 'pointer' }}>
                        logout
                    </span>
                </div>
            </div>
            <div className='flex flex-row p-2 bg-custom-gray'>
                <div className='p-2 mr-2' style={{ border: '1px solid gray', background: ' #2c3e50 ' }}>
                    <button className='text-white' onClick={() => addPanel(api)}>Add</button>
                </div>
                <div className='p-2 mr-2' style={{ border: '1px solid gray', background: ' #2c3e50 ' }}>
                    <button className='text-white' onClick={saveLayout}>Save</button>
                </div>


                <div className="dropdown-container">

                    <div className='p-2 mr-2 dropdown-button' style={{ border: '1px solid gray', background: ' #2c3e50 ' }}>
                        <button className='text-white' onClick={toggleDropdown}>Chart</button>
                    </div>
                    {isDropdownVisible && (
                        <div className="dropdown-box">
                            <div className="dropdown-row">
                                <label htmlFor="dropdown1" className="dropdown-title">
                                    TEMPLATE
                                </label>
                                <select
                                    name="dropdown1"
                                    id="dropdown1"
                                    onChange={handleDropdownChange}
                                    value={selectedValues.dropdown1}
                                    className="dropdown-select"
                                >
                                    <option disabled>Select Design</option>
                                    <option value="Green and Blue">Green and Blue</option>
                                    <option value="Red and Blue">Red and Blue</option>
                                    <option value="Blue and Pink">Blue and Pink</option>
                                </select>
                            </div>
                            <div className="dropdown-row">
                                <label htmlFor="dropdown2" className="dropdown-title">
                                    SYMBOL
                                </label>
                                <select
                                    name="dropdown2"
                                    id="dropdown2"
                                    onChange={handleDropdownChange}
                                    value={selectedValues.dropdown2}
                                    className="dropdown-select"
                                >
                                    <option value="AUD / CAD" selected>AUD / CAD</option>
                                    <option value="Option 1">Option 1</option>
                                    <option value="Option 2">Option 2</option>
                                    <option value="Option 3">Option 3</option>
                                </select>
                            </div>
                            <div className="dropdown-row">
                                <label htmlFor="dropdown3" className="dropdown-title">
                                    TIMEFRAME
                                </label>
                                <select
                                    name="dropdown3"
                                    id="dropdown3"
                                    onChange={handleDropdownChange}
                                    value={selectedValues.dropdown3}
                                    className="dropdown-select"
                                >
                                    <option value="M1" selected>M1</option>
                                    <option value="Option 1">Option 1</option>
                                    <option value="Option 2">Option 2</option>
                                    <option value="Option 3">Option 3</option>
                                </select>
                            </div>
                            <div className="submit-button-container">
                                <button onClick={() => addPanel(api)} className="submit-button">
                                    NEW CHART
                                </button>
                            </div>
                        </div>
                    )}
                </div>


            </div>
            <div
                style={{
                    flexGrow: 1,
                }}
            >
                <DockviewReact
                    components={components}
                    onReady={onReady}
                    rightHeaderActionsComponent={RightComponent}
                    className={`${props.theme || 'dockview-theme-vs'}`} />
            </div>
        </div>
    );
};

export default DockviewPersistence;































